import React from "react";
import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const SamsaraFinish = lazyLoader(
  () => import("Containers/SamsaraIntegration/SamsaraFinish/SamsaraFinish")
);

export const SamsaraFinishPage = () => {
  return (
    <Layout>
      <SamsaraFinish />
    </Layout>
  );
};
